/**
 * Maps Stripe product IDs to internal tier names.
 * LIVE MODE — production Stripe products.
 *
 * Boltway™ Pro (monthly + annual) — prod_UKTrAc6PONTAsk
 * Boltway™ Enterprise (monthly + annual) — prod_UKTrt2Q99hpqHu
 */
export const STRIPE_PRODUCT_TIER_MAP: Record<string, 'pro' | 'enterprise'> = {
  'prod_UKTrAc6PONTAsk': 'pro',         // Pro (monthly + annual)
  'prod_UKTrt2Q99hpqHu': 'enterprise',  // Enterprise (monthly + annual)
};

export function tierFromProductId(productId: string | null): 'free' | 'pro' | 'enterprise' {
  if (!productId) return 'free';
  return STRIPE_PRODUCT_TIER_MAP[productId] ?? 'free';
}
